import React,{useEffect} from 'react';
import Home from './Home';

export default function Weightrx() {
  useEffect(()=> {
    window.scrollTo(0,0);
  },[]);

  return <Home />;
}